import AuthService from "../session/AuthService";

class http {
  HEADERS() {
    return {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: "JWT fefege...",
    };
  }
  
  AUTH_HEADERS() {
    return {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: AuthService.getToken(),
    };
  }


  MULTIPART_HEADERS() {
    return {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
      Authorization: AuthService.getToken(),
    };
  }
}
export default new http();

/*
import AuthService from "../session/AuthService";

class http {
    HEADERS() {
        return {
            'Content-Type': 'application/json',
            'Accept' : '///*',
            'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI5ODQzMTA2ODgxIiwiZXhwIjoxNTk1Mjc2ODE0LCJpYXQiOjE1OTUyNTg4MTR9.c67R4WmJvS_BsHbtrAKOYYAf7Uwa1YDmik0xD18A9QoYCsJZpcnopxDWP_hE0RHyS4Qqu9xIKvWO5S0ftEYEnA'
        };
    }
    AUTH_HEADERS() {
        return {
            'Content-Type': 'application/json',
            'Accept' : '///*',
            'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI5ODQzMTA2ODgxIiwiZXhwIjoxNTk1Mjc2ODE0LCJpYXQiOjE1OTUyNTg4MTR9.c67R4WmJvS_BsHbtrAKOYYAf7Uwa1YDmik0xD18A9QoYCsJZpcnopxDWP_hE0RHyS4Qqu9xIKvWO5S0ftEYEnA',
        }
    }
}
export default new http();*/
